import { DownloadIcon } from "@/components/icons";
import { Menu, MENU_ICON_SIZE, type MenuItem as BlockItem } from "@/components/Menu";

export interface MenuItem {
  key: string;
  label: string;
  /** A download — the item is a link (`download`), not a button. */
  href?: string;
  onSelect?: () => void;
  /** A rule above this item — before the gesture that changes the record. */
  separatorBefore?: boolean;
}

/** A download carries its arrow, as every „Herunterladen" in the record (UX gate round 2, #6). */
function asBlockItem(item: MenuItem): BlockItem {
  return {
    key: item.key,
    label: item.label,
    href: item.href,
    download: item.href !== undefined ? true : undefined,
    icon: item.href !== undefined ? <DownloadIcon size={MENU_ICON_SIZE} /> : undefined,
    onSelect: item.onSelect,
    separatorBefore: item.separatorBefore,
  };
}

/**
 * One menu per record entry (UX ruling 8, F-6): the original, „als Zeichnung
 * übernehmen" per attachment the reading takes, and — apart — „Eintrag
 * zurückziehen …". The rare gesture with consequences no longer stands on
 * every entry, and the attachment chips are plain downloads.
 *
 * The behaviour is `Menu`'s. What is the record's own: a download is a link
 * with the arrow, and the items without one keep the arrow's column free so
 * the whole menu has one text edge (round-4 screen check, R4-7) — the
 * block's icon-column rule. Choosing an item gives the focus back to the
 * button **before** the item acts, so a dialog the item opens returns there
 * when it closes.
 */
export function EntryMenu({ label, items }: { label: string; items: readonly MenuItem[] }) {
  return <Menu label={label} items={items.map(asBlockItem)} />;
}
